import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../redux/hooks';
import { RootState } from '../../redux/rootReducer';
import { onboardingActions } from '../../redux/onboarding/onboardingSlice';
import CustomModal from '../Common/CustomModal';
import StyledButton from '../Common/StyledButton';

const OnboardingSuccessModal = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const open = useAppSelector((state: RootState) => state.onboarding.onboardingSuccesModalOpen);

  const handleOnClick = () => {
    dispatch(onboardingActions.closeOnboardingSuccessModal());
  };

  return (
    <CustomModal isOpen={open} width={391}>
      <Box width={391} minHeight={398} padding="52px 32px 36px 32px">
        <Grid container alignItems="center" flexDirection="column" gap={2} textAlign="center">
          <Box component="img" src="/assets/icons/confetti-onboard.svg" />
          <Typography variant="title2Bold" color="primary.main">
            {t('therapistOnboarding.onboardingSuccessModal.title')}
          </Typography>
          <Typography variant="bodyRegular" color="primary.main" pb={4}>
            {t('therapistOnboarding.onboardingSuccessModal.description')}
          </Typography>
          <StyledButton onClick={handleOnClick}>
            {t('therapistOnboarding.onboardingSuccessModal.gotIt')}
          </StyledButton>
        </Grid>
      </Box>
    </CustomModal>
  );
};

export default OnboardingSuccessModal;
